import { render, staticRenderFns } from "./BusinessMatchHome.vue?vue&type=template&id=5ba726f4&scoped=true"
import script from "./BusinessMatchHome.vue?vue&type=script&lang=ts"
export * from "./BusinessMatchHome.vue?vue&type=script&lang=ts"
import style0 from "./BusinessMatchHome.vue?vue&type=style&index=0&id=5ba726f4&prod&lang=scss&scoped=true"
import style1 from "./BusinessMatchHome.vue?vue&type=style&index=1&id=5ba726f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba726f4",
  null
  
)

export default component.exports